import {createSlice} from "@reduxjs/toolkit";
import empowermentV2Service from "../../../../services/roaming/roamingEmpowermentV2Service";
import EventBus from "../../../eventbus/EventBus";
import {attachPkcs7WithTimestamp, createPkcs7WithTimestamp} from "../eimzo/eimzoReducer";
import {
    CUSTOMER_CANCEL_EMPOWERMENT_V2_FAILED,
    CUSTOMER_CANCEL_EMPOWERMENT_V2_REQUESTED,
    CUSTOMER_CANCEL_EMPOWERMENT_V2_SUCCESS,
    EMPOWERMENT_V2_DRAFT_FAILED,
    EMPOWERMENT_V2_DRAFT_REQUESTED,
    EMPOWERMENT_V2_DRAFT_SUCCESS,
    EMPOWERMENT_V2_SEND_FAILED,
    EMPOWERMENT_V2_SEND_REQUESTED,
    EMPOWERMENT_V2_SEND_SUCCESS,
    EXECUTOR_ACCEPT_EMPOWERMENT_V2_FAILED,
    EXECUTOR_ACCEPT_EMPOWERMENT_V2_REQUESTED,
    EXECUTOR_ACCEPT_EMPOWERMENT_V2_SUCCESS,
    EXECUTOR_DECLINE_EMPOWERMENT_V2_FAILED,
    EXECUTOR_DECLINE_EMPOWERMENT_V2_REQUESTED,
    EXECUTOR_DECLINE_EMPOWERMENT_V2_SUCCESS,
    PERSON_ACCEPT_EMPOWERMENT_V2_FAILED,
    PERSON_ACCEPT_EMPOWERMENT_V2_REQUESTED,
    PERSON_ACCEPT_EMPOWERMENT_V2_SUCCESS,
    PERSON_DECLINE_EMPOWERMENT_V2_FAILED,
    PERSON_DECLINE_EMPOWERMENT_V2_REQUESTED,
    PERSON_DECLINE_EMPOWERMENT_V2_SUCCESS,
    SYNC_EMPOWERMENT_V2_FAILED,
    SYNC_EMPOWERMENT_V2_REQUESTED,
    SYNC_EMPOWERMENT_V2_SUCCESS
} from "../../../eventbus/roaming/roamingEmpowermentV2Events";
import {VIEWER_CUSTOMER, VIEWER_DRAFT, VIEWER_EXECUTOR, VIEWER_PERSON} from "../../../../enum/EmpowermentStatus";
import {Translate} from "../main/mainReducer";

const t = Translate;

export const roamingEmpowermentV2Slice = createSlice({
    name: 'roamingEmpowermentV2',
    initialState: {
        empowerments: [],
        filterOptions: {page: 1, limit: 10},
        countEmpowerments: 0,
        isLoading: false,
        viewPage: {
            id: null,
            draftId: null,
            showModal: false
        }
    },
    reducers: {
        setShowModal: (state, action) => {
            if (!action.payload) {
                state.viewPage = {id: null, draftId: null, showModal: false}
            } else {
                state.viewPage.showModal = action.payload
            }
        },
        setId: (state, {payload}) => {
            const {draftId, id} = payload
            if (draftId) {
                state.viewPage.draftId = draftId
            } else if (id) {
                state.viewPage.id = id
            }
        },
        updateEmpowerments: (state, action) => {
            state.empowerments = action.payload
        },
        updateCountEmpowerments: (state, action) => {
            state.countEmpowerments = action.payload
        },
        updateFilterOptions: (state, action) => {
            state.filterOptions = {...state.filterOptions, ...action.payload}
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        }
    },
})

export const sendEmpowermentV2Async = async (certificate, lang, hashcode) => {
    EventBus.dispatch(EMPOWERMENT_V2_SEND_REQUESTED, hashcode);
    let errorResponse;
    await createPkcs7WithTimestamp(hashcode, certificate.keyId)
        .then(async ({pkcs7: signature}) => {
            await empowermentV2Service.sendEmpowermentV2({signature: signature, lang})
                .then((response) => {
                    EventBus.dispatch(EMPOWERMENT_V2_SEND_SUCCESS, response.data);
                    return response.data;
                })
                .catch(error => {
                    errorResponse = errorSender(error.response.data, lang)
                    EventBus.dispatch(EMPOWERMENT_V2_SEND_FAILED, errorResponse);
                })
        })
        .catch(error => {
            errorResponse = {message: t(lang, "roaming.empowerment.alert.error.createPkcs7Async")};
            EventBus.dispatch(EMPOWERMENT_V2_SEND_FAILED, errorResponse);
        })
};

export const draftEmpowermentV2Async = async (empowermentDraftSend) => {
    EventBus.dispatch(EMPOWERMENT_V2_DRAFT_REQUESTED)

    return new Promise((resolve, reject) => {
        empowermentV2Service.draftEmpowermentV2(empowermentDraftSend)
            .then(response => {
                EventBus.dispatch(EMPOWERMENT_V2_DRAFT_SUCCESS, response.data)
                resolve(response.data)
            })
            .catch(error => {
                EventBus.dispatch(EMPOWERMENT_V2_DRAFT_FAILED)
                reject(error)
            })
    })
}


export const customerCancelEmpowermentV2Async = async (certificate, id, lang) => {
    EventBus.dispatch(CUSTOMER_CANCEL_EMPOWERMENT_V2_REQUESTED, id);
    let errorResponse;
    await empowermentV2Service.getCancelHashCode(id)
        .then(async ({data: hashCode}) => {
            await createPkcs7WithTimestamp(hashCode, certificate.keyId)
                .then(async ({pkcs7: signature}) => {
                    await empowermentV2Service.customerCancelEmpowermentV2({id, signature: signature})
                        .then((response) => {
                            EventBus.dispatch(CUSTOMER_CANCEL_EMPOWERMENT_V2_SUCCESS, response.data)
                            return response.data;
                        })
                        .catch(error => {
                            errorResponse = errorSender(error.response.data, lang)
                            EventBus.dispatch(CUSTOMER_CANCEL_EMPOWERMENT_V2_FAILED, errorResponse);
                        })
                })
                .catch(error => {
                    errorResponse = {message: t(lang, "roaming.empowerment.alert.error.createPkcs7Async")}
                    EventBus.dispatch(CUSTOMER_CANCEL_EMPOWERMENT_V2_FAILED, errorResponse);
                })
        })
        .catch(error => {
            errorResponse = {message: t(lang, "roaming.empowerment.alert.error.getCancelHashCode")}
            EventBus.dispatch(CUSTOMER_CANCEL_EMPOWERMENT_V2_FAILED, errorResponse);
        })
};
export const personAcceptEmpowermentV2Async = async (certificate, id, lang) => {
    EventBus.dispatch(PERSON_ACCEPT_EMPOWERMENT_V2_REQUESTED, id);
    let errorResponse;
    await empowermentV2Service.getAcceptHashCode(id)
        .then(async ({data: hashCode}) => {
            await attachPkcs7WithTimestamp(hashCode, certificate.keyId)
                .then(async ({pkcs7: roamingPkcs7}) => {
                    await empowermentV2Service.personAcceptEmpowermentV2({id, signature: roamingPkcs7})
                        .then((response) => {
                            EventBus.dispatch(PERSON_ACCEPT_EMPOWERMENT_V2_SUCCESS, response.data)
                            return response.data;
                        })
                        .catch(error => {
                            errorResponse = errorSender(error.response.data, lang);
                            EventBus.dispatch(PERSON_ACCEPT_EMPOWERMENT_V2_FAILED, errorResponse);
                        })
                })
                .catch(error => {
                    errorResponse = {message: t(lang, "roaming.empowerment.alert.error.attachPkcs7Async")};
                    EventBus.dispatch(PERSON_ACCEPT_EMPOWERMENT_V2_FAILED, errorResponse);
                })
        })
        .catch(error => {
            errorResponse = {message: t(lang, "roaming.empowerment.alert.error.getAcceptHashCode")};
            EventBus.dispatch(PERSON_ACCEPT_EMPOWERMENT_V2_FAILED, errorResponse);
        })
};
export const personDeclineEmpowermentV2Async = async (certificate, payload, lang) => {
    EventBus.dispatch(PERSON_DECLINE_EMPOWERMENT_V2_REQUESTED, payload);
    let errorResponse;
    const {id, comment} = payload;
    await empowermentV2Service.getDeclineHashCode(id, comment)
        .then(async ({data: hashCode}) => {
            await createPkcs7WithTimestamp(hashCode, certificate.keyId)
                .then(async ({pkcs7: signature}) => {
                    await empowermentV2Service.personDeclineEmpowermentV2({id, signature: signature, comment})
                        .then((response) => {
                            EventBus.dispatch(PERSON_DECLINE_EMPOWERMENT_V2_SUCCESS, response.data)
                            return response.data;
                        })
                        .catch(error => {
                            errorResponse = errorSender(error.response.data, lang)
                            EventBus.dispatch(PERSON_DECLINE_EMPOWERMENT_V2_FAILED, errorResponse);
                        })
                })
                .catch(error => {
                    errorResponse = {message: t(lang, "roaming.empowerment.alert.error.createPkcs7Async")}
                    EventBus.dispatch(PERSON_DECLINE_EMPOWERMENT_V2_FAILED, errorResponse);
                })
        })
        .catch(error => {
            errorResponse = {message: t(lang, "roaming.empowerment.alert.error.getDeclineHashCode")}
            EventBus.dispatch(PERSON_DECLINE_EMPOWERMENT_V2_FAILED, errorResponse);
        })
};
export const executorAcceptEmpowermentV2Async = async (certificate, id, lang) => {
    EventBus.dispatch(EXECUTOR_ACCEPT_EMPOWERMENT_V2_REQUESTED, {id});
    let errorResponse;
    await empowermentV2Service.getAcceptHashCode(id)
        .then(async ({data: hashCode}) => {
            await attachPkcs7WithTimestamp(hashCode, certificate.keyId)
                .then(async ({pkcs7: roamingPkcs7}) => {
                    await empowermentV2Service.executorAcceptEmpowermentV2({id, signature: roamingPkcs7})
                        .then((response) => {
                            EventBus.dispatch(EXECUTOR_ACCEPT_EMPOWERMENT_V2_SUCCESS, response.data)
                            return response.data;
                        })
                        .catch(error => {
                            errorResponse = errorSender(error.response.data, lang);
                            EventBus.dispatch(EXECUTOR_ACCEPT_EMPOWERMENT_V2_FAILED, errorResponse);
                        })
                })
                .catch(error => {
                    errorResponse = {message: t(lang, "roaming.empowerment.alert.error.attachPkcs7Async")};
                    EventBus.dispatch(EXECUTOR_ACCEPT_EMPOWERMENT_V2_FAILED, errorResponse);
                })
        })
        .catch(error => {
            errorResponse = {message: t(lang, "roaming.empowerment.alert.error.getAcceptHashCode")};
            EventBus.dispatch(EXECUTOR_ACCEPT_EMPOWERMENT_V2_FAILED, errorResponse);
        })
};
export const executorDeclineEmpowermentV2Async = async (certificate, payload, lang) => {
    EventBus.dispatch(EXECUTOR_DECLINE_EMPOWERMENT_V2_REQUESTED, payload);
    let errorResponse;
    const {id, comment} = payload;
    await empowermentV2Service.getDeclineHashCode(id, comment)
        .then(async ({data: hashCode}) => {
            await createPkcs7WithTimestamp(hashCode, certificate.keyId)
                .then(async ({pkcs7: signature}) => {
                    await empowermentV2Service.executorDeclineEmpowermentV2({
                        id, signature: signature, comment
                    })
                        .then(response => {
                            EventBus.dispatch(EXECUTOR_DECLINE_EMPOWERMENT_V2_SUCCESS, response.data)
                            return response.data;
                        })
                        .catch(error => {
                            errorResponse = errorSender(error.response.data, lang)
                            EventBus.dispatch(EXECUTOR_DECLINE_EMPOWERMENT_V2_FAILED, errorResponse);
                        })
                })
                .catch(error => {
                    errorResponse = {message: t(lang, "roaming.empowerment.alert.error.createPkcs7Async")}
                    EventBus.dispatch(EXECUTOR_DECLINE_EMPOWERMENT_V2_FAILED, errorResponse);
                })
        })
        .catch(error => {
            errorResponse = {message: t(lang, "roaming.empowerment.alert.error.getDeclineHashCode")}
            EventBus.dispatch(EXECUTOR_DECLINE_EMPOWERMENT_V2_FAILED, errorResponse);
        })

};
export const syncEmpowermentV2Async = (id) => {
    EventBus.dispatch(SYNC_EMPOWERMENT_V2_REQUESTED, id);
    return new Promise((resolve, reject) => {
        empowermentV2Service.syncEmpowermentV2(id)
            .then((response) => {
                EventBus.dispatch(SYNC_EMPOWERMENT_V2_SUCCESS, id);
                resolve(response.data);
            })
            .catch((error) => {
                let errorMessage = {message: error.response.data}
                EventBus.dispatch(SYNC_EMPOWERMENT_V2_FAILED, errorMessage);
                reject(error);
            })
    })

};

export const loadEmpowermentV2Async = (id) => {
    return new Promise((resolve, reject) => {
        empowermentV2Service.getEmpowermentV2(id)
            .then((response) => resolve(response.data))
            .catch((error) => reject(error))
    })
}

export const loadDraftEmpowermentV2 = async (id) => {
    return new Promise((resolve, reject) => {
        empowermentV2Service.getEmpowermentDraftV2(id)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const loadEmpowermentsV2Async = (viewer, params) => (dispatch) => {
    switch (viewer) {
        case VIEWER_CUSTOMER:
            dispatch(loadCustomerEmpowermentsV2Async(params));
            dispatch(loadCustomerCountEmpowermentsV2Async(params));
            break;
        case VIEWER_EXECUTOR:
            dispatch(loadExecutorEmpowermentsV2Async(params));
            dispatch(loadExecutorCountEmpowermentsV2Async(params));
            break;
        case VIEWER_PERSON:
            dispatch(loadPersonEmpowermentsV2Async(params));
            dispatch(loadPersonCountEmpowermentsV2Async(params));
            break;
        case VIEWER_DRAFT:
            dispatch(loadDraftEmpowermentsV2Async(params))
            dispatch(loadDraftCountEmpowermentsV2Async(params))
            break;
    }
};

export const loadCustomerEmpowermentsV2Async = ({page, limit, ...filters}) => (dispatch) => {
    dispatch(roamingEmpowermentV2Slice.actions.setLoading(true));
    const skip = (page - 1) * limit;
    const params = {skip, limit, ...filters};
    empowermentV2Service.getCustomerEmpowermentsV2(params)
        .then(response => {
            dispatch(roamingEmpowermentV2Slice.actions.updateEmpowerments(response.data));
            dispatch(roamingEmpowermentV2Slice.actions.setLoading(false));
        })
        .catch(error => {
            console.log(error);
            dispatch(roamingEmpowermentV2Slice.actions.setLoading(false));
        })
};
export const loadPersonEmpowermentsV2Async = ({page, limit, ...filters}) => (dispatch) => {
    dispatch(roamingEmpowermentV2Slice.actions.setLoading(true));
    const skip = (page - 1) * limit
    const params = {skip, limit, ...filters}
    empowermentV2Service.getPersonEmpowermentsV2(params)
        .then(response => {
            dispatch(roamingEmpowermentV2Slice.actions.updateEmpowerments(response.data));
            dispatch(roamingEmpowermentV2Slice.actions.setLoading(false));
        })
        .catch(error => {
            console.log(error);
            dispatch(roamingEmpowermentV2Slice.actions.setLoading(false));
        })
};
export const loadExecutorEmpowermentsV2Async = ({page, limit, ...filters}) => (dispatch) => {
    dispatch(roamingEmpowermentV2Slice.actions.setLoading(true));
    const skip = (page - 1) * limit
    const params = {skip, limit, ...filters}
    empowermentV2Service.getExecutorEmpowermentsV2(params)
        .then(response => {
            dispatch(roamingEmpowermentV2Slice.actions.updateEmpowerments(response.data));
            dispatch(roamingEmpowermentV2Slice.actions.setLoading(false));
        })
        .catch(error => {
            console.log(error);
            dispatch(roamingEmpowermentV2Slice.actions.setLoading(false));
        })
};
export const loadDraftEmpowermentsV2Async = ({page, limit, ...filters}) => (dispatch) => {
    dispatch(roamingEmpowermentV2Slice.actions.setLoading(true));
    const skip = (page - 1) * limit
    const params = {skip, limit, ...filters}
    empowermentV2Service.getExecutorDraftEmpowermentsV2(params)
        .then(response => {
            dispatch(roamingEmpowermentV2Slice.actions.updateEmpowerments(response.data));
            dispatch(roamingEmpowermentV2Slice.actions.setLoading(false))
        })
        .catch(error => {
            console.log(error)
            dispatch(roamingEmpowermentV2Slice.actions.setLoading(false))
        })
}

export const loadCustomerCountEmpowermentsV2Async = ({limit, page, ...other}) => (dispatch) => {
    empowermentV2Service.getCustomerCountEmpowermentsV2(other)
        .then(response => {
            dispatch(roamingEmpowermentV2Slice.actions.updateCountEmpowerments(response.data))
        })
        .catch(error => {
            console.log(error);
        })
};
export const loadPersonCountEmpowermentsV2Async = ({limit, page, ...other}) => (dispatch) => {
    empowermentV2Service.getExecutorCountEmpowermentsV2(other)
        .then(response => {
            dispatch(roamingEmpowermentV2Slice.actions.updateCountEmpowerments(response.data))
        })
        .catch(error => {
            console.log(error);
        })
};
export const loadExecutorCountEmpowermentsV2Async = ({limit, page, ...other}) => (dispatch) => {
    empowermentV2Service.getPersonCountEmpowermentsV2(other)
        .then(response => {
            dispatch(roamingEmpowermentV2Slice.actions.updateCountEmpowerments(response.data))
        })
        .catch(error => {
            console.log(error);
        })
};
export const loadDraftCountEmpowermentsV2Async = ({limit, page, ...other}) => (dispatch) => {
    empowermentV2Service.getExecutorCountDraftEmpowermentsV2(other)
        .then(response => {
            dispatch(roamingEmpowermentV2Slice.actions.updateCountEmpowerments(response.data))
        })
        .catch(error => {
            console.log(error)
        })
}

export const changeFilterOptionsAsync = params => dispatch => {
    return dispatch(roamingEmpowermentV2Slice.actions.updateFilterOptions(params))
};

export const printEmpowermentV2Async = (id) => {
    return new Promise((resolve, reject) => {
        empowermentV2Service.printEmpowermentV2(id)
            .then(response => resolve(response.data))
            .catch(error => {
                console.log(error);
                reject(error)
            })
    })
}
const errorSender = (errorResponse, lang) => {
    let detectedError;
    if (errorResponse.content)
        detectedError = {message: JSON.parse(errorResponse.content).ErrorMessage}
    else if (errorResponse.not_allowed_inn)
        detectedError = {message: t(lang, 'roaming.empowerment.alert.not_allowed_inn')}
    else if (errorResponse.content_parse_failed)
        detectedError = {message: t(lang, 'roaming.empowerment.alert.content_parse_failed')}
    else
        detectedError = {message: t(lang, 'roaming.empowerment.alert.default_error')}
    return detectedError;
};

export const viewPage = state => state.roamingEmpowerment.viewPage
export const selectIsLoading = state => state.roamingEmpowerment.isLoading;
export const selectEmpowerments = state => state.roamingEmpowerment.empowerments;
export const selectCountEmpowerments = (state) => state.roamingEmpowerment.countEmpowerments;
export const selectFilterOptions = (state) => state.roamingEmpowerment.filterOptions;


export default roamingEmpowermentV2Slice.reducer;
export const {setShowModal, setId} = roamingEmpowermentV2Slice.actions
